import React, { useEffect, useState } from 'react';
import { submitInviteRequest } from '../../services/inviteService';
import './InviteFormModal.css';

const MAX_REQUEST_CHARS = 500;

const InviteFormModal = ({ isOpen, onClose, initialFocus = 'email' }) => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [request, setRequest] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setResult(null);

    const res = await submitInviteRequest({ email, phone, name, request });
    setResult(res);
    setIsSubmitting(false);

    if (res.success) {
      // Clear sensitive fields on success but keep the modal open so the
      // confirmation message is visible.
      setEmail('');
      setPhone('');
      setName('');
      setRequest('');
    }
  };

  const requestRemaining = MAX_REQUEST_CHARS - request.length;

  return (
    <div
      className="invite-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="invite-modal-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="invite-modal">
        <button
          type="button"
          className="invite-modal-close"
          onClick={onClose}
          aria-label="Închide"
        >
          ×
        </button>

        <h2 id="invite-modal-title" className="invite-modal-title">
          Vreau invitație
        </h2>
        <p className="invite-modal-subtitle">
          Lasă-ne datele tale și îți trimitem pe email linkul de înregistrare
          pentru abonamentul Pro (99 RON/lună, 100 credite incluse).
        </p>

        {result?.success ? (
          <div className="invite-modal-success">
            <p className="invite-modal-success-title">Mulțumim!</p>
            <p className="invite-modal-success-body">{result.message}</p>
            <button
              type="button"
              className="invite-modal-submit"
              onClick={onClose}
            >
              Închide
            </button>
          </div>
        ) : (
          <form className="invite-modal-form" onSubmit={handleSubmit} noValidate>
            <label className="invite-modal-label">
              Email <span className="invite-modal-required">*</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus={initialFocus === 'email'}
                disabled={isSubmitting}
                placeholder="email@exemplu.ro"
              />
            </label>

            <label className="invite-modal-label">
              Telefon <span className="invite-modal-optional">(opțional)</span>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                disabled={isSubmitting}
                placeholder="07XX XXX XXX"
              />
            </label>

            <label className="invite-modal-label">
              Nume Prenume / Nume Companie{' '}
              <span className="invite-modal-optional">(opțional)</span>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                disabled={isSubmitting}
                placeholder="Nume Prenume sau Nume Companie"
              />
            </label>

            <label className="invite-modal-label">
              Solicitare <span className="invite-modal-optional">(opțional)</span>
              <textarea
                value={request}
                onChange={(e) =>
                  setRequest(e.target.value.slice(0, MAX_REQUEST_CHARS))
                }
                rows={4}
                disabled={isSubmitting}
                placeholder="Spune-ne pe scurt ce te interesează (max. 500 caractere)"
              />
              <span
                className={
                  requestRemaining < 50
                    ? 'invite-modal-counter low'
                    : 'invite-modal-counter'
                }
              >
                {requestRemaining} caractere rămase
              </span>
            </label>

            {result && !result.success && (
              <p className="invite-modal-error">{result.message}</p>
            )}

            <button
              type="submit"
              className="invite-modal-submit"
              disabled={isSubmitting || !email}
            >
              {isSubmitting ? 'Se trimite…' : 'Trimite cererea'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default InviteFormModal;
